module.exports = __webpack_public_path__ + "img/trade-03.3bf41039.svg";